import { useQuery } from '@tanstack/react-query'

import { errorToast } from 'common/components/toastNotification'

import { fetchMetabaseDashboardUrl } from '../api'
import { reportsKeys } from '../queryKeys/reportsKeys'

const useGetMetabaseDashboardUrlQuery = (
  dashboardId: string | undefined,
  accountId: string | undefined
) => {
  return useQuery(
    reportsKeys.metabaseDashboardUrl(dashboardId ?? '', accountId ?? ''),
    () => fetchMetabaseDashboardUrl(dashboardId!, accountId!),
    {
      enabled: !!dashboardId && !!accountId,
      staleTime: 10 * 60 * 1000,
      onError: () => {
        errorToast('Failed to load dashboard. Please try again.')
      },
    }
  )
}

export default useGetMetabaseDashboardUrlQuery
